import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router, RouterEvent, NavigationStart } from '@angular/router';
import { filter, debounceTime, map, tap, switchMap, finalize } from 'rxjs/operators';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ConfigurationSettings } from 'src/app/models/configuration.settings';
import { HttpClient } from '@angular/common/http';
import { HubConnection } from '@microsoft/signalr';
import { CommunicationService } from 'src/app/services/shared/communication/communication.service';
import { ToasterService } from 'src/app/services/shared/toaster/toaster.service';
import { Subscription } from 'rxjs';
import { UserService } from 'src/app/services/core/user/user.service';
import { IHandOffComments } from 'src/app/models/handoff-comment';
import { TokenService } from 'src/app/services/core/token/token.service';
import { IChatHistory, IConversationHistory } from 'src/app/models/chat-history';

@Component({
  selector: 'app-add-new-agent',
  templateUrl: './add-new-agent.component.html',
  styleUrls: ['./add-new-agent.component.scss']
})
export class AddNewAgentComponent implements OnInit { 
  _routerSubscription: any;
  botInfo: any;
  agentHandOffComment: string;
  AddLeaveClicked: boolean = false;
  addAgentClicked: boolean = false;
  handOffDetails: IHandOffComments;
  type: string;
  allSelected: boolean = true;
  isValidChatManagerRole = false;
  private _hubConnection: HubConnection;
  activeChatbotHistory: IChatHistory[] = [];
  hasAssociatedBot: boolean = false;
  associatedBotName: string;
  associatedBotId: number;
  isAssociatedBotAgents: boolean = false;
  isActiveAgentsTab: boolean;
  isActiveAssociatedAgentsTab: boolean;

  private _subscriptions = new Subscription();

  agentsInfo = [];
  allagentsInfo = []
  allAssociatedAgentsInfo = [];
  selectedActiveAgent: any;

  showActiveAgentsCardContainer = false;
  showSelectedActiveAgentContainer = false;

  constructor(private dialogRef: MatDialogRef<AddNewAgentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
    private configurationSettings: ConfigurationSettings,
    private http: HttpClient,
    private service: CommunicationService,
    private toasterService: ToasterService,
    private userService: UserService,
    private tokenService: TokenService) {    
      this.addAgentClicked = false;  
  }

  ngOnInit() {
    this._routerSubscription = this.router.events
      .pipe(
        filter((event: RouterEvent) => event instanceof NavigationStart),
        filter(() => !!this.dialogRef)
      )
      .subscribe(() => {
        this.dialogRef.close();
      });

    this.botInfo = JSON.parse(this.data); /* console.log(this.botInfo);*/

    this.hasAssociatedBot = this.botInfo.HasAssociatedBot;
    this.associatedBotId = this.botInfo.AssociatedBotId;
    this.associatedBotName = this.botInfo.AssociatedBotName;

    this.getAllActiveAgentsInfo(this.botInfo.BotConfigId);
    this._hubConnection = this.service.GetHubConnection();
    this.isValidChatManagerRole = this.botInfo.IsValidChatManagerRole;
  }

  AddAgentNew(selectedAgent: any) {
    this.addAgentClicked = true;
    if (selectedAgent.emailAddress.toLowerCase() == this.botInfo.AddedByAgentId.toLowerCase()) {
      this.toasterService.error("Error: Invalid Agent selection");
    }
    else {

      let currentAgentChatHistory = this.botInfo.Conversations.map(item => { 
        return {
          date: new Date(),
          botConversations: [
            {
              sender: item.Sender,
              message: item.Message,
              type: item.Type == "send" || (item.Type == "receive" && item.Sender != this.botInfo.BotUserName) ? 'Agent' : item.Type == "receive" && item.Sender == this.botInfo.BotUserName ? 'User' : (item.Type == "addNotification" || item.Type == "removeNotification") ? 'System' : 'Bot',
              date: item.DateTime,
              conversationId: item.ConversationId
            }
          ]
        }
      })

      currentAgentChatHistory.forEach(e => {
        if (e.message == '*#grant') {
          e.message = 'Permission granted for file upload';
        }

      })

      //Below line was commented,ChatHistory contains many data, due to heavy data passing to middleware, the connection gets closed in between, will reload all the chats via middleware to portal
      //currentAgentChatHistory.forEach(item => this.botInfo.ChatHistory.push(item));

      var today = new Date();
      var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
      var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      var currentDateTime = date + ' ' + time;
      this.handOffDetails = {
        handOffBy: 'Agent ' + this.botInfo.AddedByAgentId,
        handOffTo: 'Agent ' + selectedAgent.emailAddress,
        handOffComment: this.agentHandOffComment,
        handOffTime: currentDateTime
      };
      this.botInfo.HandOffInfo.push(this.handOffDetails);
      const botInfoForAddAgent =
      {
        BotId: this.botInfo.BotId,
        BotConfigId: this.botInfo.BotConfigId,
        BotUserId: this.botInfo.BotUserId,
        ConversationId: this.botInfo.ConversationId,
        BotUserName: this.botInfo.BotUserName,
        ChatHistory: currentAgentChatHistory, // passing current agent-user conversations
        HandOffInfo: this.botInfo.HandOffInfo,
        Domain: "",
        BotName: this.botInfo.BotName,
        NewAgentId: selectedAgent.emailAddress,
        AddedByAgentId: this.botInfo.AddedByAgentId,
        HandOffTime: currentDateTime,
        HasAssociatedBot: this.hasAssociatedBot,
        IsAssociatedBotAgent: this.isAssociatedBotAgents,
        AssociatedBotConfigId: this.associatedBotId,
        AssociatedBotName: this.associatedBotName
      }
        

      if (this.AddLeaveClicked) {
        let method = "AgentEscalationAddAndLeave";
        this._hubConnection
          .invoke(method, botInfoForAddAgent)
          .then(() => {
            this.onClose()
          })
          .catch(err => {
            this.toasterService.error("Error : " + err.message.toString());
          })
      } else {
        let method = "AgentEscalationAddAndStay";
        this._hubConnection
          .invoke(method, botInfoForAddAgent)
          .then(() => {
            this.onClose()
          })
          .catch(err => {
          })
      }
    }
  }

  onAddLeaveClick(): void {
    this.AddLeaveClicked = true;
    this.AddAgentNew(this.selectedActiveAgent);
  }

  onAddStayClick(): void {
    this.AddLeaveClicked = false;
    this.AddAgentNew(this.selectedActiveAgent);
  }

  applyAgentTypeFilter(agentRole: any) {
    this.closeSelectedActiveAgentCard();
    if (agentRole != "All") {
      this.allSelected = false;
      this.agentsInfo = [];
      if (this.allagentsInfo && this.allagentsInfo.length > 0) {
        this.agentsInfo = this.allagentsInfo.filter(x => x.userAgentRole == agentRole || x.userAgentRole == "Both");
        this.isAssociatedBotAgents = false; // to hide/ show Add & Stay Button based on Agent selection, if the selected agent is an Associated Bot Agent
      }
      if (agentRole == "AssociatedAgent") {
        if (this.allAssociatedAgentsInfo && this.allAssociatedAgentsInfo.length > 0) {
          this.agentsInfo = this.allAssociatedAgentsInfo.filter(x => x.userAgentRole == agentRole);
          this.isAssociatedBotAgents = true; // to show Add & Stay Button based on Agent selection, if the selected agent is an Associated Bot Agent
        }
      }
    }
    else {
      this.allSelected = true;
      this.agentsInfo = this.allagentsInfo;
      this.isAssociatedBotAgents = false; // to hide/ show Add & Stay Button based on Agent selection, if the selected agent is an Associated Bot Agent
    }

    if (agentRole == "AssociatedAgent") {
      this.isActiveAssociatedAgentsTab = true;
      this.isActiveAgentsTab = false;
    }
    else {
      this.isActiveAssociatedAgentsTab = false;
      this.isActiveAgentsTab = true;
    }

  }

  getAllActiveAgentsInfo(botConfigId: number) {
    this._subscriptions.add(
      this.userService.getAllActiveAgents(botConfigId, this.associatedBotId)
        .subscribe(
          res => {           
            let allActiveAgents = res.filter(x => x.emailAddress.toLowerCase() != this.botInfo.AddedByAgentId.toLowerCase() && this.botInfo.GroupChatAgents.agentEmailId.indexOf(x.emailAddress.toLowerCase()) < 0);
            this.allagentsInfo = allActiveAgents.filter(x => x.userAgentRole != 'AssociatedAgent');
            this.agentsInfo = allActiveAgents.filter(x => x.userAgentRole != 'AssociatedAgent'); // Avoiding to get associated agents list in initiall agent escalation pop up
            this.allAssociatedAgentsInfo = allActiveAgents.filter(x => x.userAgentRole == 'AssociatedAgent'); // To obtain associated agents to a seperate array

            this.isActiveAgentsTab = true;
            this.showActiveAgentsCardContainer = true;
            this.showSelectedActiveAgentContainer = false;
            this.allSelected = true;
          },
          (error) => {
            console.log("Error in Escalate getAllActiveAgentsInfo: ");
            console.log(error);
            if (error != 'Internal Server Error')
              this.getRefreshToken();
            else
              this.toasterService.error("Unable to retrieve active Agents");
          }
        )
    )
  }

  getRefreshToken() {
    console.log("GetRefreshToken called for Escalate")
    this.tokenService.getRefreshToken()
      .subscribe(
        res => {
          let objToken = res;
          localStorage.setItem('accessToken', objToken.token);
          localStorage.setItem('refreshToken', objToken.refreshToken);
          this.getAllActiveAgentsInfo(this.botInfo.BotConfigId);
        },
        (error) => {
          console.log("Error in Escalate GetRefreshToken:");
          console.log(error);
        }
      );
  }

  closeSelectedActiveAgentCard() {
    this.showActiveAgentsCardContainer = true;
    this.showSelectedActiveAgentContainer = false;
  }

  onActiveAgentSelection(activeAgent: any) {
    this.selectedActiveAgent = activeAgent;    
    this.showActiveAgentsCardContainer = false;
    this.showSelectedActiveAgentContainer = true;
  }

  onClose() {
    this.dialogRef.close('Close');
  }

}
